<template>
  <div class="dashboard">
    <!-- 顶部统计卡片 -->
    <el-row :gutter="20" class="mb-20">
      <el-col :span="6">
        <div class="card visit">
          <div class="card-title">在线乘客数</div>
          <div class="card-value">{{passengerOnline}}</div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="card turnover">
          <div class="card-title">今日乘客注册量</div>
          <div class="card-value">{{passengerRegister}}</div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="card download">
          <div class="card-title">在线司机数</div>
          <div class="card-value">{{ driverOnline }}</div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="card deal">
          <div class="card-title">今日司机注册量</div>
          <div class="card-value">{{driverRegister}}</div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="card driverOnline">
          <div class="card-title">今日司机总在线时长</div>
          <div class="card-value">{{driverOnlineTime}}/分钟</div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="card passengerH5Register">
          <div class="card-title">今日乘客H5注册数量</div>
          <div class="card-value">{{passengerH5Register}}</div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="card passengerAndroidRegister">
          <div class="card-title">今日乘客Android注册数量</div>
          <div class="card-value">{{passengerAndroidRegister}}</div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="card passengerIOSRegister">
          <div class="card-title">今日乘客IOS注册数量</div>
          <div class="card-value">{{passengerIOSRegister}}</div>
        </div>
      </el-col>
    </el-row>

    <!-- 中间图表 -->
    <el-row :gutter="20">
      <el-col :span="14">
        <div class="chart-box" ref="lineChart"></div>
      </el-col>
      <el-col :span="10">
        <div class="chart-box" ref="pieChart"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import echarts from "echarts";
import {
  passenger_online,
  passenger_register,
  driver_online,
  driver_register,
  driver_online_time, passenger_count
} from '@/api/home/index.js'
export default {
  name: "Dashboard",
  mounted() {
    this.initCardData();
  },
  data(){
    return {
      passengerOnline:0,
      passengerRegister:0,
      driverOnline:0,
      driverRegister:0,
      driverOnlineTime:0,
      passengerH5Register:0,
      passengerAndroidRegister:0,
      passengerIOSRegister:0,
    }
  },
  methods: {
    initCardData() {
      passenger_online().then(res => {
        this.passengerOnline = res.data
      });
      passenger_register().then(res => {
        this.passengerRegister = res.data
      });
      driver_online().then(res => {
        this.driverOnline = res.data
      });
      driver_register().then(res => {
        this.driverRegister = res.data
      });
      driver_online_time().then(res => {
        this.driverOnlineTime = res.data
      });
      passenger_count().then(res => {
        this.passengerH5Register = res.data.bigbeeH5
        this.passengerAndroidRegister = res.data.bigbeeAndroid
        this.passengerIOSRegister = res.data.bigbeeiOS
      });

    },
    // 折线/面积图
    initLineChart() {
      let chart = echarts.init(this.$refs.lineChart);
      chart.setOption({
        tooltip: { trigger: "axis" },
        legend: { data: ["Download Count", "Register Count"] },
        xAxis: { type: "category", data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"] },
        yAxis: { type: "value" },
        series: [
          {
            name: "Download Count",
            type: "line",
            smooth: true,
            areaStyle: { color: "rgba(100, 149, 237, 0.3)" },
            data: [5000, 6000, 6500, 7000, 4800, 5300, 6000]
          },
          {
            name: "Register Count",
            type: "line",
            smooth: true,
            areaStyle: { color: "rgba(0, 206, 209, 0.3)" },
            data: [7000, 8000, 9500, 11000, 6000, 7000, 6500]
          }
        ]
      });
    },
    // 环形图
    initPieChart() {
      let chart = echarts.init(this.$refs.pieChart);
      chart.setOption({
        tooltip: { trigger: "item" },
        legend: { top: "5%", left: "center" },
        series: [
          {
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            itemStyle: { borderRadius: 10, borderColor: "#fff", borderWidth: 2 },
            label: { show: false },
            data: [
              { value: 1048, name: "A" },
              { value: 735, name: "B" },
              { value: 580, name: "C" },
              { value: 484, name: "D" }
            ]
          }
        ]
      });
    }
  }
};
</script>

<style scoped>
.dashboard {
  padding: 20px;
}
.mb-20 {
  margin-bottom: 20px;
}
.card {
  border-radius: 10px;
  padding: 20px;
  color: #fff;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
}
.card-title {
  font-size: 14px;
}
.card-value {
  font-size: 24px;
  margin-top: 10px;
}
.visit {
  background: linear-gradient(to right, #ff5f6d, #ffc371);
}
.turnover {
  background: linear-gradient(to right, #6a11cb, #2575fc);
}
.download {
  background: linear-gradient(to right, #36d1dc, #5b86e5);
}
.deal {
  background: linear-gradient(to right, #f7971e, #ffd200);
}
.driverOnline {
  background: linear-gradient(to right, #99b320, #00ff0d);
}
.passengerH5Register {
  background: linear-gradient(to right, #9c6783, #da55a5);
}
.passengerAndroidRegister {
  background: linear-gradient(to right, #465993, #4778ba);
}
.passengerIOSRegister {
  background: linear-gradient(to right, #69aca2, #00f7ff);
}
.chart-box {
  background: #fff;
  border-radius: 10px;
  height: 300px;
  padding: 10px;
}
</style>
